import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { ComponentsCommunicationService } from 'src/app/services/components-communication.service';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { AvatarsSignaturesDialogComponent } from '../my-users/avatars-signatures-dialog/avatars-signatures-dialog.component';
import { ApiSitesService } from 'src/app/services/api.sites.service';
import { EditSiteDialogComponent } from './edit-site-dialog/edit-site-dialog.component';
import { ApiWorkareasService } from 'src/app/services/api.workareas.service';
import { ApiUsersService } from 'src/app/services/api.users.service';
import { SharedFunctionsService } from 'src/app/services/shared-functions.service';
import { RolesService } from 'src/app/services/roles.service';

@Component({
  selector: 'my-sites',
  templateUrl: './my-sites.component.html',
  styleUrls: ['./my-sites.component.scss'],
})
export class MySitesComponent {
  sitesUpdate!: Subscription;
  getRolesListUpdate!: Subscription;
  @ViewChild('searchInput')
  searchInput!: ElementRef<HTMLInputElement>;
  reducedColumns: string[] = ['title', 'active', 'actions'];
  fullColumns: string[] = [
    'title',
    'licenseLevel',
    'email',
    'phone',
    'url',
    'active',
    'actions',
  ];
  displayedColumnsUsers: string[] = ['name', 'email', 'role'];
  displayedColumnsWorkareas: string[] = [
    'title',
    'site',
    'siteSupplier',
    'clientAcceptance',
    'active',
    'actions',
  ];
  displayedColumnsRoles: string[] = ['role', 'users'];
  displayedColumns: any;
  isLoading = false;
  isLoadingUsers = false;
  contentLoading = false;
  displayDetails = false;
  isLoadingWorkareas = false;
  isLoadingRoles = false;
  detailsLoading = false;
  activeRowId = '';
  dataSource: any = [
    { name: ' Person 1' },
    { name: ' person 2' },
    { name: ' person 3' },
  ];
  dataSourceUsers: any = [];
  dataSourceWorkareas: any = [];
  dataSourceRoles: any = [];
  searchFilter = '';
  selectedItem: any;
  detailsTab = 0;
  roles = {
    isAdmin: false,
    imReader: false,
    systemRoles: [],
    allRoles: [],
    tenantRoles: [],
  };
  paginatorConfig: any = {
    pageIndex: 0,
    length: 0,
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50, 100],
  };

  constructor(
    public sharedFunctions: SharedFunctionsService,
    public rolesService: RolesService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private apiSitesService: ApiSitesService,
    private apiWorkareasService: ApiWorkareasService,
    private componentsCommunication: ComponentsCommunicationService,
    private apiUsersService: ApiUsersService
  ) {}

  ngOnInit() {
    this.displayedColumns = this.fullColumns;
    this.getData();
    this.getRolesListUpdate = this.componentsCommunication.getRolesList().subscribe(data => {
      // is admin
      if (data && data.length > 0 &&  data[0].tenantId === null && this.rolesService.systemAdmin(data[0].roles)){
        this.roles.isAdmin = true;      
      }
      if (data && data.length > 1){
        this.roles.systemRoles = data[0].roles;
        this.roles.allRoles = data.slice(1);
      }  
      });
    this.sitesUpdate = this.componentsCommunication
      .getUpdateSites()
      .subscribe((params: any) => {
        // updates the list
        if (params && params.name == 'update_sites') {          
          if (params.action != 'tenant_update' && this.selectedItem) {
            this.getRoles();
          }
          this.getData(params.action);
          const tenantId = localStorage.getItem('selectedSiteId');

          // when the tenant dropdown triggers a tenant changes, it has to review the roles
          if (
            tenantId &&
            tenantId.length > 0 &&
            params.action == 'tenant_update'
          ) {
            this.resetShowDetails();
          /* this.roles.tenantRoles = this.rolesService.checkTenantRoles(
              this.roles.allRoles,
              tenantId
            );*/
          }
          // when no tenant is selected, applies the system roles
          if (tenantId?.length == 0) {
           // this.roles.tenantRoles = this.roles.systemRoles;
          }
          if (this.selectedItem && params.type && params.type == 'sitelogo' && params.action != 'tenant_update') {
            this.getLogo(this.selectedItem);
            this.loadDetails(this.selectedItem);
          }
        }
      });
  }

  ngOnDestroy() {
    this.sitesUpdate.unsubscribe();
    this.getRolesListUpdate.unsubscribe();
  }

  getData(action?: string) {
    this.isLoading = true;
    this.dataSource = [];
    const type = 'privilege';
    const tenantId = localStorage.getItem('selectedSiteId');
    const params = {
      tenantId: tenantId && tenantId.length > 0 ? tenantId : '',
      lookupName: type,
      first: this.paginatorConfig.pageIndex,
      max: this.paginatorConfig.pageSize,
      sort: 'asc',
      sortColumn: 'dateCreated',
    };

    this.apiSitesService.getTenantsList(params).subscribe(
      (result: any) => {
        if (result.content.length > 0) {
          this.dataSource = result.content;
          this.paginatorConfig.length = result.totalElements;
          //this updates the current selected item
          if (this.selectedItem && this.selectedItem?.id) {
            this.selectedItem = this.dataSource.find((elem: any)=>this.selectedItem.id == elem.id);        
            this.getLogo(this.selectedItem);  
          } 
        }
        this.isLoading = false;
        //keeps details visible if they were visible
        if (
          this.displayDetails &&
          result.length > 0 &&
          action &&
          action == 'disable'
        ) {
          this.loadDetails(this.selectedItem);
        }
      },
      // error
      (msg) => {
        console.log('error retrieving lookup list ' + msg);
        this.isLoading = false;
      }
    );
  }

  createSite(id?: string) {
    const params = {
      userId: id ? id : '',
      action: id ? 'edit' : 'create',
    };

    this.dialog.open(EditSiteDialogComponent, {
      height: 'auto',
      width: 'auto',
      disableClose: true,
      autoFocus: false,
      data: params,
    });
  }

  //triggers the search
  siteSearch() {
    //this.isLoading = true;
    this.contentLoading = true;

    let searchTerm: any;
    searchTerm = encodeURIComponent(this.searchInput.nativeElement.value);    
    const tenantId = localStorage.getItem('selectedSiteId');   
    const params = {
      tenantId: tenantId && tenantId.length > 0 ? tenantId : '', 
      searchTerm: searchTerm,
      first: this.paginatorConfig.pageIndex,
      max: this.paginatorConfig.pageSize,
      sort: 'desc',
    };

    if (searchTerm.trim().length > 0) {
      this.apiSitesService.searchSites(params).subscribe(
        (result: any) => {
          if (result.totalElements > 0) {
            this.dataSource = result.content;
            this.paginatorConfig.length = result.totalElements; // this.dataSource.totalElements;
          } else {
            // empty results
            this.dataSource = [];
            this.paginatorConfig.length = 0;
            this.displayDetails = false;
          }
          this.contentLoading = false;
        },
        // error
        (msg) => {
          console.log(msg);
          this.isLoading = false;
          this.contentLoading = false;
          this.dataSource = [];
        }
      );
    } else if (searchTerm.trim().length == 0) {
      this.contentLoading = false;
      this.resetShowDetails();
      this.getData();
    }
  }

  actions() {}

  preview(element: any) {}

  loadDetails(element: any) {
    if (
      (
        this.roles.isAdmin ||
        this.rolesService.systemAdmin(this.roles.systemRoles) ||
        this.rolesService.supervisor(this.roles.systemRoles)) &&
      (!this.selectedItem || element.id != this.selectedItem.id)
    ) {
      this.displayDetails = true;
      this.detailsLoading = true;
      this.displayedColumns = this.reducedColumns;
      this.selectedItem = element;
      this.activeRowId = element.id;
      this.getSiteUsers(element.id);
      this.getSiteWorkareas(element.id);
      this.getLogo(element);
      this.getRoles();
    }
  }

  getLogo(element: any) {
    const params = {
      tenantId: element.id,
    };
    this.apiSitesService.getSiteLogo(params).subscribe(
      (result) => {
        if (result) {
          element.urlLogo = result;
        }
        this.detailsLoading = false;
      },
      // error
      (msg) => {
        console.log(msg);
        this.detailsLoading = false;
        if (msg.status == '400') {
          console.log('no logo found');
        }
      }
    );
  }

  getRoles() {
    this.isLoadingRoles = true;
    this.dataSourceRoles = [];
    const tenantId = localStorage.getItem('selectedSiteId');
    const params = {
      elemId: this.selectedItem.id,
    };

    this.apiSitesService.getRoles(params).subscribe(
      (result: any) => {
        if (result.length > 0) {
          this.dataSourceRoles = result;
        }
        this.isLoadingRoles = false;
      },
      // error
      (msg) => {
        console.log('error retrieving the list ' + msg);
        this.isLoadingRoles = false;
      }
    );
  }

  //GET /tenant/users/list
  getSiteUsers(tenantId: string) {
    this.isLoadingUsers = true;
    const params = {
      tenantId: tenantId,
    };
    this.apiSitesService.getSiteUsers(params).subscribe(
      (result) => {
        if (result) {
          this.dataSourceUsers = result;
        }
        this.isLoadingUsers = false;
      },
      // error
      (msg) => {
        console.log(msg);
        this.isLoadingUsers = false;
      }
    );
  }

  //GET /user/listWorkAreas/{userId}
  getSiteWorkareas(tenantId: string) {
    this.isLoadingWorkareas = true;
    const params = {
      tenantId: tenantId, // this is the tenantd selected in the tenant's list.
      userId: localStorage.getItem('username')
    }
    this.apiUsersService.getTenantWorkareas(params).subscribe(
      (result: any) => {
        if (result.content){
          this.dataSourceWorkareas = result.content;                   
        } 
        this.isLoadingWorkareas = false;
      },
      // error
      (msg) => {
        console.log(msg);
        this.isLoadingWorkareas = false;
      }
    );
  }

  /**
   * resets the persisting data from showing the asset details
   */
  resetShowDetails() {
    this.activeRowId = '';
    this.displayDetails = false;
    this.selectedItem = {};
    this.detailsTab = 0;
    this.displayedColumns = this.fullColumns;
  }

  /**
   * deactivate or enable the selected element from the list
   * @param element selected element to be deactivated or enabled
   */
  disableSite(element: any) {
    const params = {
      tenantId: element.id,
      enabled: !element.active,
    };
    const properties = {
      name: 'update_sites',
      action: element.action,
    };

    this.apiSitesService.disableSite(params).subscribe(
      (result) => {
        const message = !params.enabled ? 'Site disabled' : 'Site enabled';
        console.log(message);
        this.snackBar.open(message, '', { duration: 3000 });

        // sends an update
        this.componentsCommunication.setUpdateSites(properties);
      },
      // error
      (msg) => {
        if (msg.status == '200') {
          const message = !params.enabled ? 'Site disabled' : 'Site enabled';
          console.log(message);
          this.snackBar.open(message, '', { duration: 3000 });
          // sends an update
          this.componentsCommunication.setUpdateSites(properties);
        }
        console.log(msg.statusText);
      }
    );
  }

  editSite(element: any) {
    element.action = 'edit';
    const dialogRef = this.dialog.open(EditSiteDialogComponent, {
      minWidth: '410px',
      disableClose: true,
      autoFocus: false,
      data: element,
    });
  }

  editLogo(element: any, type: string) {
    element.type = type;
    element.action = 'edit';
    const dialogRef = this.dialog.open(AvatarsSignaturesDialogComponent, {
      minWidth: '410px',
      disableClose: true,
      autoFocus: false,
      data: element,
    });
  }

  confirmation(action: string, elem?: any) {
    elem.action = action;
    elem.confirmation = false;
    if (action == 'disable') {
      const message = elem.active
        ? 'Disable the selected Site?'
        : 'Enable the selected Site?';
      elem.confirmationString = message;
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '200px',
      width: '440px',
      disableClose: true,
      autoFocus: false,
      data: elem,
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data.confirmation) {
        this.disableSite(elem);
      }
    });
  }

  tabChanged(tabChangeEvent: any) {
    this.detailsTab = tabChangeEvent.index;
  }

  create(id?: string) {
    const params = {
      tenant: id ? id : '',
      action: id ? 'edit' : 'create',
      type: 'logo',
    };

    this.dialog.open(AvatarsSignaturesDialogComponent, {
      height: 'auto',
      width: 'auto',
      disableClose: true,
      autoFocus: false,
      data: params,
    });
  }

  /**
   * handles the pagination ant the update of the results
   * @param evt click event
   */
  handlePage(evt: any) {
    //this.displayDetails = false;
    this.paginatorConfig.pageIndex = evt.pageIndex;
    this.paginatorConfig.pageSize = evt.pageSize;
    //triggers the search after updating the pagination
    this.getData();
  }
}
